import { render, staticRenderFns } from "./CustomerDeliveryAddress.vue?vue&type=template&id=5ce73025&"
import script from "./CustomerDeliveryAddress.vue?vue&type=script&lang=js&"
export * from "./CustomerDeliveryAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports